import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div`
  /* Ensure the body fills whatever space remains */
  flex-grow: 2 !important;
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const SiteBody = ({ children }) => (
  <Layout className="SiteBody">{children}</Layout>
)

SiteBody.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

export default SiteBody
